import * as React from "react";
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import { Chip } from '@material-ui/core';

export const BooleanField = (props) => {
  const { source, falsyValueLabel, truthyValueLabel, neutralValueLabel } = props;
  const record = useRecordContext(props);

  
  let label = truthyValueLabel || "Bloqueado";
  let color = "#fff0f0";
  if (record[source] === null) {
    label = neutralValueLabel || "Não moderado";
    color = "#e8faff";
  } else if (record[source]) {
    label = falsyValueLabel || "Aprovado";
    color = "#eefee6";
  }

  if (label == "Bloqueado" && record['reports_count'] && record['reports_count'] >= 2) {
    label = 'Denunciado';
  }

  return <Chip
    label={label}
    size="small"
    style={{
      backgroundColor: color,
      border: 0
    }}
  />;
};

BooleanField.propTypes = {
  record: PropTypes.object,
  falsyValueLabel: PropTypes.string,
  truthyValueLabel: PropTypes.string,
  neutralValueLabel: PropTypes.string,
};